//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions } from "vuex";
import router from "../../router";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 15, // current rows per page being displayed
        sortBy: "orderNumber",
        descending: true,
      },
      unfilteredOrders: [],
      orders: [],
      orderOptions: [
        // { value: 41001, name: this.$t("order.status-41001") },
        { value: 200, name: this.$t("order.status-200") },
        { value: 300, name: this.$t("order.status-300") },
        { value: 400, name: this.$t("order.status-400") },
        { value: 500, name: this.$t("order.status-500") },
        { value: 600, name: this.$t("order.status-600") },
        { value: 700, name: this.$t("order.status-700") },
      ],
      orderStatuses: [],
      filter: "",
      customers: [],
      title: this.$t("nav.salesReturn"),
      //orderId: 0,
      invoiceNr: "",

      dense: true,
      componentKey: 0,

      columns: [
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          style: "width: 200px",
          field: "orderNumber",
          sortable: true,
        },
        {
          name: "customerNumber",
          align: "left",
          label: this.$t("order.customerNumber"),
          field: "customerNumber",
          sortable: true,
        },
        {
          name: "customerName",
          align: "left",
          label: this.$t("order.customerName"),
          field: "customerName",
          sortable: true,
        },
        {
          name: "ourReference",
          align: "left",
          label: this.$t("order.ourReference"),
          field: "ourReference",
          sortable: true,
        },
        {
          name: "orderDate",
          align: "left",
          label: this.$t("order.orderDate"),
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "customerOrderStatusId",
          align: "left",
          label: this.$t("order.status"),
          field: "customerOrderStatusId",
          format: (val) => this.$t("order.status-" + val),
          sortable: true,
        },
      ],
      columnsOrderLine: [
        {
          name: "productNumber",
          align: "left",
          label: this.$t("order.productNumber"),
          field: (row) => row.productNumber,
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: this.$t("order.productName"),
          field: (row) => row.productName,
          sortable: true,
        },
        {
          name: "quantity",
          align: "left",
          label: this.$t("order.quantity"),
          field: (row) => row.numberOfItems,
          sortable: true,
        },
        {
          name: "returned",
          align: "right",
          label: this.$t("order.qtyReturned"),
          field: "returned",
          sortable: true,
        },
        {
          name: "joinedSerialNumbers",
          align: "left",
          label: this.$t("pick.serialNumbers"),
          field: (row) => row.joinedSerialNumbers,
          style: "max-width: 200px;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "customerOrderItemStatusId",
          align: "left",
          label: this.$t("order.itemStatus"),
          field: "customerOrderItemStatusId",
          format: (val) => this.$t("order.itemStatus-" + val),
          sortable: true,
        },
      ],
      numberOfSelectedOrderStatusesThatAreDisplayed: 0,
      countOfOrderStatusChars: 0,
      displayedOrderStatuses: [],
    };
  },

  async mounted() {
    await this.refresh();
  },

  computed: {
    orderStatusDisplaySelected() {
      let result = "";

      for (let i = 0; i < this.numberOfSelectedOrderStatusesThatAreDisplayed; i++) {

        const orderStatusString = "order.status-" + this.orderStatuses[i];

        if (!this.$t(orderStatusString)) continue;
        result += this.$t(orderStatusString) + ", ";
      }

      result = result.slice(0, -2);

      if (this.countOfOrderStatusChars > 80) {
        result += "...";
      }

      return result;
    }
  },

  watch: {
    orderStatuses(newValue, oldValue) {
      if (newValue != oldValue) {
        this.refresh();
      }

      let countOfChars = 0;
      for (let i = 0; i < this.orderStatuses.length; i++) {
        const orderValue = this.orderStatuses[i];
        const orderStatusString = "order.status-" + orderValue;

        countOfChars += this.$t(orderStatusString).length;
      }
      this.countOfOrderStatusChars = countOfChars;

      let visibleCount = 0;
      let runningLength = 0;
      for (const orderStatus of this.orderStatuses) {
        const orderStatusName = "order.status-" + orderStatus

        if (!this.$t(orderStatusName)) continue;
        if (runningLength + this.$t(orderStatusName).length > 80) break;
        runningLength += this.$t(orderStatusName).length;
        visibleCount++;
      }
      this.numberOfSelectedOrderStatusesThatAreDisplayed = visibleCount;
    },
  },
  methods: {
    filterSearch(val) {
      if (!this.unfilteredOrders) {
        return;
      }
      if (val.length > 1) {
        this.orders = this.unfilteredOrders.filter(
          (o) =>
            o.orderNumber
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1 ||
            (o.customerNumber &&
              o.customerNumber.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (o.customerName &&
              o.customerName.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (o.ourReference &&
              o.ourReference.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (o.orderDate &&
              o.orderDate
                .toString()
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1) ||
            (o.deliveryDate &&
              o.deliveryDate.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            o.orderItems.filter(
              (l) =>
                l.productNumber.toLowerCase().indexOf(val.toLowerCase()) > -1
            ).length > 0 ||
            o.orderItems.filter(
              (l) => l.productName.toLowerCase().indexOf(val.toLowerCase()) > -1
            ).length > 0 ||
            o.orderItems.filter(
              (l) =>
                l.joinedSerialNumbers &&
                l.joinedSerialNumbers.toLowerCase().indexOf(val.toLowerCase()) >
                  -1
            ).length > 0
        );
      } else {
        this.orders = this.unfilteredOrders;
      }
    },

    openOrder(orderId) {
      router.push({ name: "ReturnOrder", params: { id: orderId } });
    },

    async searchByInvoiceNr() {
      var order = await this.getReturnOrderFromInvoice(this.invoiceNr);
      if (order != null) {
        this.openOrder(order.id);
      }
    },

    async refresh() {
      this.unfilteredOrders = [];
      this.orders = [];
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.unfilteredOrders = await this.getReturnOrders(this.orderStatuses);
      this.orders = this.unfilteredOrders;

      setTimeout(() => {
        notif();
      }, 500);
    },

    ...mapActions("main", ["getReturnOrders", "getReturnOrderFromInvoice"]),
  },
};
